var slider = {
  single: $(".slider-single:not(.widget-carousel-new)"),
  productCarousel: $(".product-carousel"),
  heroSlider: $(".slider-hero"),
  barSlider: $(".slider-cta"),
  multiItem: $(".slider-manual.slider-full"),
  multiItem4: $(".slider-manual.slider-fullx4"),
  multiItem5: $(".slider-manual.slider-fullx5"),
  multiCentredItem: $(".slider-manual.slider-centred"),
  multiStyleCentredItem: $(".style-slider-centred"),

  inputField: $(".slider-single").find(
    'input[type="text"], input[type="email"]'
  ),

  // New sliders
  syncSimple: $(".slider-sync-simple"),
  syncComplex: $(".slider-sync-complex"),

  durationList: $(".timedSlider").map(function(index, item) {
    return item.getAttribute("data-time");
  }),

  adjustSyncComplexMargin: function(nextSlide, isNextSlide) {
    if (isTouch && $(window).width() <= 1023) {
      //get video height (code changes according to nextslide or current)
      if (isNextSlide) {
        var $slideEl = slider.syncSimple.find(
          '[data-slick-index="' + nextSlide + '"]'
        );
      } else {
        var $slideEl = slider.syncSimple.find(".slick-active");
      }
      var syncSimpleHeight = slider.syncSimple.outerHeight();
      var videoHeight = $slideEl
        .find(".mobile-hero")
        .find(".video-js")
        .outerHeight();
      if (videoHeight != null) {
        //set margin top and width of sync complex
        slider.syncComplex.css(
          "margin-top",
          videoHeight - syncSimpleHeight - 30
        );
        slider.syncComplex.css("width", "100%");
        $slideEl.find(".mobile-hero").css("background-image", "none");
      } else {
        slider.syncComplex.css("width", "96%");
        slider.syncComplex.css("margin-top", "-15rem");
      }
    }
  },

  videosInSliders: function(nextSlide) {
    var $nextSlideEl = slider.syncSimple.find(
      '[data-slick-index="' + nextSlide + '"]'
    );
    var $nextSlideVideo = $nextSlideEl.find(".video-cover");

    if ($nextSlideEl.find(".video-js").length) {
      slider.adjustSyncComplexMargin(nextSlide, true);
    } else {
      slider.syncComplex.css("width", "96%");
      slider.syncComplex.css("margin-top", "-15rem");
    }

    if ($nextSlideVideo.length) {

      var mobileDisplay = $nextSlideEl
        .find(".mobile-hero");
      var desktopDisplay = $nextSlideEl
        .find(".desktop-hero");

      if (desktopDisplay.css("display") != "none" && desktopDisplay.find(".auto-play-desktop").length > 0) {
        videojs.getPlayer(desktopDisplay.find("video").attr("id")).muted(true);
        videos.playVideo(desktopDisplay.find(".video-cover"));
      } else if (mobileDisplay.css("display") != "none" && mobileDisplay.find(".auto-play-mobile").length > 0) {
        videojs.getPlayer(mobileDisplay.find("video").attr("id")).muted(true);
        videos.playVideo(mobileDisplay.find(".video-cover"));
      }
    } else {
      videos.pauseOther();
    }
  },

  moveContentDown: function(nextSlide) {
    var $nextComplexSlideEl = slider.syncComplex.find(
      '[data-slick-index="' + nextSlide + '"]'
    );

    if (isTouch) {
      slider.syncComplex.removeClass("move-down");
      videos.pauseOther();
    } else {
      if ($nextComplexSlideEl.find(".slide-content-header.move-down").length) {
        slider.syncComplex.addClass("move-down");
      } else {
        slider.syncComplex.removeClass("move-down");
      }
    }
  },

  handleMobile: function() {
    // get content to it's original position
    slider.syncComplex.removeClass("move-down");
    // Pause video
    videos.pauseOther();
    // Show back cover once slide animation has finished. why timeout?
    // setTimeout(function(){
    // 	slider.syncSimple.find('.hidden-cover').removeClass('hidden-cover').fadeIn('fast');
    // }, 800);
    // console.log('handleMobile FADE IN ');
    slider.syncSimple
      .find(".hidden-cover")
      .removeClass("hidden-cover")
      .fadeIn("fast");
  },

  setupSync: function() {
    slider.syncComplex.on("init", function() {
      $(".slider-hero-content").addClass("hero-home-loaded");
    });
    slider.syncSimple.slick({
      useTransform: true,
      speed: 800,
      mobileFirst: true,
      accessibility: true,
      arrows: false,
      // autoplaySpeed: 6000,
      dots: false,
      asNavFor: ".slider-sync-complex",
      // adaptiveHeight: false,
      rtl: window.rtl,
      responsive: [
        {
          breakpoint: 660,
          settings: {
            speed: 500
          }
        },
        {
          breakpoint: 360,
          settings: {
            speed: 400
          }
        }
      ]
    });
    slider.syncComplex.on("init", function() {
      setTimeout(function() {
        slider.checkScrollPos();
      }, 50);
    });
    slider.syncComplex.on("beforeChange", function() {
      slider.checkScrollPos();
    });
    slider.syncComplex.slick({
      useTransform: true,
      speed: 800,
      mobileFirst: true,
      accessibility: true,
      arrows: true,
      prevArrow: '<a href="#" class="slick-prev slick-arrow"></a>',
      nextArrow: '<a href="#" class="slick-next slick-arrow"></a>',
      autoplay: false,
      autoplaySpeed: 8000,
      asNavFor: ".slider-sync-simple",
      adaptiveHeight: true,
      rtl: window.rtl,
      responsive: [
        {
          breakpoint: 660,
          settings: {
            speed: 500
          }
        },
        {
          breakpoint: 360,
          settings: {
            speed: 400
          }
        }
      ]
    });
  },

  checkScrollPos: function() {
    // console.log('checkScrollPos')
    if (
      $(document).scrollTop() >
      slider.syncComplex.offset().top + slider.syncComplex.height()
    ) {
      videos.pauseOther();
      slider.syncComplex.slick("slickPause");
    }
    $(window).scroll(
      throttle(function(event) {
        if (
          $(document).scrollTop() >
          slider.syncComplex.offset().top + slider.syncComplex.height()
        ) {
          slider.syncComplex.slick("slickPause");
          videos.pauseOther();
        } else {
          // the slider should not play after being paused
          // it's bad UX and a major cause of headache for devs, pms, client and end-users (e.g. video pausing bug)
        }
      }, 500)
    );
  },

  smallProducts: function() {
    var sliderContentProducts = $(".small-product-carousel");
    if (sliderContentProducts.length) {
      sliderContentProducts.each(function() {
        var _this = $(this);
        if (_this.hasClass("slick-initialized")) {
          _this.slick("unslick");
        }
        var swipeEnabled = true;
        if (_this.closest(".slider-sync-complex").length) {
          swipeEnabled = false;
        }
        _this.slick({
          useTransform: true,
          speed: 500,
          accessibility: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: swipeEnabled,
          rtl: window.rtl,
          prevArrow: '<a href="#" class="slick-prev slick-arrow"></a>',
          nextArrow: '<a href="#" class="slick-next slick-arrow"></a>'
        });
      });
    }
  },

  setupSingle: function() {
    slider.single.each(function() {
      $(this).slick({
        useTransform: true,
        speed: 800,
        mobileFirst: true,
        accessibility: true,
        arrows: false,
        autoplaySpeed: 6000,
        rtl: window.rtl,
        responsive: [
          {
            breakpoint: 660,
            settings: {
              speed: 200
            }
          },
          {
            breakpoint: 360,
            settings: {
              speed: 200
            }
          }
        ]
      });
    });
  },

  setupProductCarousel: function() {
    slider.productCarousel.each(function() {
      var _this = $(this);
      _this.slick({
        useTransform: true,
        speed: 400,
        mobileFirst: true,
        accessibility: true,
        arrows: true,
        rtl: window.rtl,
        prevArrow: '<a href="#" class="slick-prev slick-arrow"></a>',
        nextArrow: '<a href="#" class="slick-next slick-arrow"></a>',
        appendArrows: _this.closest(".module-new")
      });
    });
  },

  autoplay: function() {
    slider.single.slick("slickPlay");
  },

  pause: function() {
    slider.single.slick("slickPause");
  },

  setupMultiItem: function() {
    var transformTrans;
    if (isTouch) {
      transformTrans = false;
    } else {
      transformTrans = true;
    }
    slider.multiItem.each(function() {
      $(this).slick({
        useTransform: transformTrans,
        speed: 500,
        accessibility: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        rtl: window.rtl,
        responsive: [
          {
            breakpoint: 660,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });
    slider.multiItem4.each(function() {
      $(this).slick({
        rtl: window.rtl,
        useTransform: true,
        speed: 500,
        accessibility: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });
    slider.multiItem5.each(function() {
      var _this = $(this);
      _this.slick({
        rtl: window.rtl,
        useTransform: true,
        speed: 500,
        accessibility: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: '<a href="#" class="slick-prev slick-arrow"></a>',
        nextArrow: '<a href="#" class="slick-next slick-arrow"></a>',
        appendArrows: _this.closest(".slider-brands-wrapper"),
        responsive: [
          {
            breakpoint: 968,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
              centerMode: true,
              centerPadding: "10%"
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: "24%"
            }
          }
        ]
      });
    });
  },

  setupStyleMultiCentredItem: function() {
    slider.multiStyleCentredItem.each(function() {
      $(this).slick({
        speed: 500,
        rtl: window.rtl,
        slidesToShow: 3,
        slidesToScroll: 1
        //,
        //responsive: [
        //    {
        //        breakpoint: 950,
        //        settings: {
        //            centerMode: true,
        //            slidesToShow: 3,
        //            slidesToScroll: 1,
        //        }
        //    }, {
        //        breakpoint: 700,
        //        settings: {
        //            centerMode: true,
        //            slidesToShow: 3,
        //            slidesToScroll: 1,
        //        }
        //    }, {
        //        breakpoint: 500,
        //        settings: {
        //            centerMode: true,
        //            slidesToShow: 3,
        //            slidesToScroll: 1,
        //        }
        //    }
        //]
      });
    });
  },

  setupMultiCentredItem: function() {
    slider.multiCentredItem.each(function() {
      $(this).slick({
        useTransform: true,
        speed: 500,
        accessibility: true,
        centerMode: true,
        centerPadding: "100px",
        rtl: window.rtl,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 950,
            settings: {
              centerMode: false,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 700,
            settings: {
              centerMode: false,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 500,
            settings: {
              centerMode: false,
              slidesToShow: 1
            }
          }
        ]
      });
    });
  },

  eventListeners: function() {
    slider.syncSimple.on("beforeChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      var $nextSlideEl = slider.syncSimple.find(
        '[data-slick-index="' + nextSlide + '"]'
      );
      var $nextSlideVideo = $nextSlideEl.find(".video-cover");
      // Don't play video if touch device
      if ($(window).width() > 1023) {
        slider.futureItem();
      }
      if (isTouch) {
        slider.handleMobile();
        slider.videosInSliders(nextSlide);
        return;
      }
      slider.moveContentDown(nextSlide);
      slider.videosInSliders(nextSlide);
    });
  },

  pauseInputFocus: function() {
    slider.inputField.focusin(function() {
      if (windowWidth >= desktop) {
        slider.pause();
      }
    });
    slider.inputField.focusout(function() {
      if (windowWidth >= desktop) {
        slider.autoplay();
      }
    });
  },

  pauseOnHover: function() {
    slider.single.mouseenter(function() {
      if (windowWidth >= desktop) {
        slider.pause();
      }
    });
    slider.single.mouseleave(function() {
      if (windowWidth >= desktop && !slider.inputField.is(":focus")) {
        slider.autoplay();
      }
    });
  },

  desktopOnly: function() {
    slider.autoplay();
    slider.pauseOnHover();
  },

  lazyLoad: function() {
    var $lazySlideItem = $(".bg-image-item");
    $lazySlideItem.each(function() {
      var $this = $(this),
        $currentClasses = $this.attr("class"),
        $numCC = $currentClasses.match(/\d+/)[0],
        $thisBgImage = $this.attr("data-largeSlideImage");

      if ($thisBgImage !== undefined) {
        if ($this.hasClass("contains-video")) {
          if ($numCC < 3) {
            $this
              .find(".video-cover")
              .css("background-image", "url(" + $thisBgImage + ")");
          }
        } else {
          if ($numCC < 3) {
            $this.css("background-image", "url(" + $thisBgImage + ")");
          }
        }
      }
    });
  },

  futureItem: function() {
    var $currentSlide = $(".slick-current .bg-image-item"),
      $slideClasses = $currentSlide.attr("class"),
      $numCC = $slideClasses.match(/\d+/)[0],
      futureNum = parseInt($numCC) + 2,
      $futureSlide = $(".bg-image-item.slide-hero-" + futureNum),
      futureSlideBG = $futureSlide.attr("data-largeSlideImage");
    if (futureSlideBG) {
      if ($futureSlide.hasClass("contains-video") === true) {
        $futureSlide
          .find(".video-cover")
          .css("background-image", "url(" + futureSlideBG + ")");
      } else {
        $futureSlide.css("background-image", "url(" + futureSlideBG + ")");
      }
    }
  },

  init: function() {
    if ($(".slider-hero-extended").length) {
      slider.setupSync();
    }

    if ($(".small-product-carousel").length) {
      slider.smallProducts();
    }

    slider.setupSingle();
    slider.setupMultiItem();
    slider.setupMultiCentredItem();
    slider.setupStyleMultiCentredItem();
    slider.pauseInputFocus();
    slider.autoplay();
    slider.pauseOnHover();
    slider.eventListeners();

    if (windowWidth >= desktop) {
      slider.desktopOnly();
    }

    if (slider.syncSimple.length) {
      $firstSlideVideo = slider.syncSimple
        .find('[data-slick-index="0"]')
        .find(".video-cover");

      if (
        slider.syncSimple
          .find('[data-slick-index="0"]')
          .find(".mobile-hero")
          .find(".video-js").length
      ) {
        slider.adjustSyncComplexMargin(null, false);
      }

      var mobileDisplay = slider.syncSimple
        .find('[data-slick-index="0"]')
        .find(".mobile-hero");

      var desktopDisplay = slider.syncSimple
        .find('[data-slick-index="0"]')
        .find(".desktop-hero");
        
      if (desktopDisplay.css("display") != "none" && desktopDisplay.find(".auto-play-desktop").length > 0) {
        videojs.getPlayer(desktopDisplay.find("video").attr("id")).muted(true);
        videos.playVideo(desktopDisplay.find(".video-cover"));
      } else if (mobileDisplay.css("display") != "none" && mobileDisplay.find(".auto-play-mobile").length > 0) {
        videojs.getPlayer(mobileDisplay.find("video").attr("id")).muted(true);
        videos.playVideo(mobileDisplay.find(".video-cover"));
      }
    }

    if (slider.productCarousel.length) {
      console.log("setupProductCarousel");
      slider.setupProductCarousel();
    }
    console.log($(window).width());
    if ($(window).width() > 1023) {
      slider.lazyLoad();
    }

    var slideIndex = 0;
    var changeSlide = function(timing) {
      setTimeout(function() {
        if (timing !== 0) {
          slider.syncSimple.slick("slickNext");
        }
        if (slideIndex >= slider.durationList.length) slideIndex = 0;
        changeSlide(slider.durationList[slideIndex++]);
      }, timing);
    };
    changeSlide(0);
  }
};

var debounce = function(func, delay) {
  var inDebounce = undefined;
  return function() {
    var context = this,
      args = arguments;
    clearTimeout(inDebounce);
    return (inDebounce = setTimeout(function() {
      return func.apply(context, args);
    }, delay));
  };
};

var throttle = function(func, limit) {
  var inThrottle;
  return function() {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function() {
        inThrottle = false;
      }, limit);
    }
  };
};
